// API 请求前缀
export const API_REQUEST_PREFIX = '/mwapi/V2';

// 基础URL
export const BASE_URL = '';

// 首页
export const HOME_URL = `${BASE_URL}/`;

// 列表限制条数
export const LIMIT = 10;

// 人民币单位
export const RMB_UNIT = '¥';

// 用户token 缓存key
export const TOKEN_NAME = 'ymba-mwapi-token';

// 小程序已登录Token
export const MINI_PROGRAM_TOKEN_NAME = 'ymba-mini-token';

// APP已登录Token
export const APP_TOKEN_NAME = 'ymba-mapi-token';

// 用户ID 缓存key
export const UID_NAME = 'YMBA-UID';

// 重定向缓存key
export const REDIRECT_NAME = 'ymbaMWRedirect';

// 分享者缓存key
export const SHARE_FROM_NAME = 'ymShareFrom';

// 分享来源缓存key
export const ORIGIN_FROM_NAME = 'ymOriginFrom';

// 分享来源缓存key
export const ENTRANCE_FROM_NAME = 'ymEntrance';

// 轮询最大次数
export const MAX_POLL = 60;

// 短信验证码相隔时长（秒）
export const SMS_CODE_DURATION = 60;

// 每秒
export const PER_SECOND = 1000;

// 每分钟
export const PER_MINUTE = PER_SECOND * 60;

// 每小时
export const PER_HOUR = PER_MINUTE * 60;

// 每天
export const PER_DAY = PER_HOUR * 24;

// 弹窗信息缓存key
export const ALERT_MESSAGE_NAME = 'YMBA_MWAPI_ALERT_MESSAGE';

// 咨询电话
export const CONSUMER_HOTLINE = '400-809-3885';

// 微信服务号
export const SERVICE_NUMBER = 'xiyouEDU';

// 提示信息缓存key
export const PROMPT_MESSAGE_NAME = 'ymbaMWPromptMessage';

// Api 平台类型key
export const PLATFORM_API_KEY = 'ymba-mwapi-platform';
// 平台类型code
export const PLATFORM_CODE = 'pc';
